import ErrorIcon from "components/svg-icons/error-icon";
import { IMaterialGroup } from "../type-definitions";
import { MaterialListItem } from "../widgets";

function NoAssigneeRhsContent({
  title,
  group
}: Readonly<{
  title: string;
  group: IMaterialGroup;
}>) {
  const materialList = group.materials ?? [];
  const hasMaterials = materialList.length > 0;

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2">
        <div className="text-sm font-semibold">{title}</div>
        {hasMaterials && (
          <div className="flex items-center space-x-1">
            <div className="form-field-heading-2">({materialList.length})</div>
            <div
              className="danger-text flex items-center"
              data-testid="info-icon"
            >
              <ErrorIcon width={16} height={16} />
            </div>
          </div>
        )}
      </div>
      {hasMaterials && (
        <div className="container-bg-color px-3 pt-3 pb-3.5 ">
          {materialList.map((material) => (
            <MaterialListItem
              material={material}
              key={material.id}
              additionalClassName="border-0 border-b border-solid border-color-1"
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default NoAssigneeRhsContent;
